export default "__VITE_ASSET__DEIei$He__"